import React, { useContext, useEffect, useState, memo, useRef, useCallback } from "react";
import axios from "axios";
import { Grid, Tooltip } from "@mui/material";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { toast } from "react-toastify";
import SitesAreaFilter from "./SitesAreaFilter";
import TenantSitesDetailsTile from "./TenantSitesDetailsTile";
import { ToggleSwitch, ToggleTitleWrapper } from "../styled/ToggleTile.styled";
import { IconWrapper2, ToggleButtonContainer } from "../styled/SidePanel.style";
import { EdotcoActionOrder, EdotcoStatusOrder, clusterDefaultZoomLvl, Names_For_Filter_OPs, DATA_ORDERS } from "../../constants/WebMap";
import { WebMapContext } from "../../pages/sections/web-map/WebMapGoogleMap";
import { getFilters, getFiltersWithLocation } from "../../services/api/filterService";
import { fetchEdotcoSiteCounts, getSiteRefs } from "../../services/api/siteService";
import { convertArrayToStringWithDelimeter } from "../../utils/helper";
import InfiniteDropdown from "./InfiniteDropdown";
import { ToolWrapper } from "../styled/PanelTools.styled";
import { Row } from "../styled/SidePanel.style";
import DialogWrapper from "../DialogWrapper";
import ScrollableTable from "../ScrollableTable";
import { getAnonymizedOperatorsByCountry } from "../../services/api/anonymizedOperators";
import ConnectionTypeGroup from "./ConnectionTypeGroup";
import SegmentedButtonGroup from "./common/SegmentedButtonGroup/SegmentedButtonGroup";
import { sortByReference } from "../../helpers/fuctionHelpers";

const EdotCoSitesCards = ({
  isSitesChecked = false,
  isECoSitesChecked = false,
  handleECoSitesToggle = () => { },
  proposedTenantsPerm,
  exitingTenantsPerm,
  ecoGAPerm,
  ecoCTPerm,
  ecoDTPerm,
  edotcoSitePerm,
}) => {
  const cancelToken = useRef();
  const TOForSiteCount = useRef(); // api timeout

  const {
    appliedFilters,
    selectedEdotcoSiteOperator,
    selectedProposedOperator,
    edotcoSiteAreaToggle,
    setEdotcoSiteAreaToggle,
    setSelectedEdotcoSiteOperator,
    setSelectedProposedOperator,
    mapZoomLevel,
    siteZoom,
    geohashNE,
    geohashSW,
    mapRef,
    setSelectedSiteRef,
    selectedSiteRefDropDown,
    setSelectedSiteRefDropDown,
    selectedSiteRef,
    edotcoSubFilters,
    setEdotcoSubFilters,
    setProposedSiteVisible,
    eyeIcons,
    operatorsPermittedECSiteET,
    operatorsPermittedECSitePT
  } = useContext(WebMapContext);

  const [siteStatusFilters, setSiteStatusFilters] = useState([]);
  const [siteActionFilters, setSiteActionFilters] = useState([]);
  const [isProposedTowersVisible, setIsProposedTowersVisible] = useState(false);
  const [siteCounts, setSiteCounts] = useState({ exisTnatMNO: [], proposedMNO: [], exisTnatNONMNO: [], proposedNONMNO: [] });
  const [viewportNE, setViewportNE] = useState([]);
  const [viewportSW, setviewportSW] = useState([]);
  const [siteRefs, setSiteRefs] = useState([]);
  const [siteRefsDetails, setSiteRefsDetails] = useState([]);
  const [edotcoDataTypes, setEdotcoDataTypes] = useState([]);
  const [edotcoConnectionTypes, setConnectionTypes] = useState([]);
  const [openAdvanceSiteRef, setOpenAdvanceSiteRef] = useState(false)
  const [advanceSiteRefData, setAdvanceSiteRefData] = useState([])
  const [masterChecked, setMasterChecked] = useState(false)
  const [mnoOperatorsETPermited, setMnoOperatorsETPermited] = useState([]);
  const [mnoOperatorsETOthers, setMnoOperatorsETOthers] = useState([]);
  const [nonMnoOperatorsETPermited, setNonMnoOperatorsETPermited] = useState([]);
  const [nonMnoOperatorsETOthers, setnonMnoOperatorsETOthers] = useState([]);
  const [mnoOperatorsProposedPermited, setMnoOperatorsProposedPermited] = useState([]);
  const [mnoOperatorsProposedOthers, setMnoOperatorsProposedOthers] = useState([]);
  const [nonMnoOperatorsProposedPermited, setNonMnoOperatorsProposedPermited] = useState([]);
  const [nonMnoOperatorsProposedOthers, setNonMnoOperatorsProposedOthers] = useState([]);
  const [isStatusFilterSet, setIsStatusFilterSet] = useState(true);

  const fetchStatusFilters = useCallback( async () => {
    try {
      const statusFilterParams = {
        adL: edotcoSiteAreaToggle && appliedFilters.level !== "geoHashLevel" ? appliedFilters.level : null,
        adLVal: edotcoSiteAreaToggle && appliedFilters.level !== "geoHashLevel" ? appliedFilters.levelVal : null,
        northEast: convertArrayToStringWithDelimeter(edotcoSiteAreaToggle && geohashNE.length ? geohashNE : viewportNE, "_"),
        southWest: convertArrayToStringWithDelimeter(edotcoSiteAreaToggle && geohashSW.length ? geohashSW : viewportSW, "_"),
        countryCode: appliedFilters.countryCode,
        year: appliedFilters.year,
        quarter: appliedFilters.quarter,
        column: "status",
        table: "edotco_site_statistics",
      };
  
      const statusFilters = {
        params: {
          groupBy: "siteRef",
          logicGate: selectedEdotcoSiteOperator?.value && selectedEdotcoSiteOperator?.operatorList?.length ? selectedEdotcoSiteOperator.value : "",
          filters: `${edotcoSubFilters?.connectionType ? "connection_type:" + edotcoSubFilters?.connectionType : ""}${edotcoSubFilters?.dataType ? ",data_type:" + edotcoSubFilters?.dataType : ""}`,
          inFilters: selectedEdotcoSiteOperator?.operatorList?.length ? "customersOnSite:" + selectedEdotcoSiteOperator.operatorList.join("|") : "",
        },
      };
  
      const statusResponse = await getFiltersWithLocation(statusFilterParams, statusFilters);
  
      if (statusResponse.success) {
        const statusMap = Object.fromEntries(statusResponse.data.map(({ _id, count }) => [_id, count]));
        const statusFilters = statusResponse.data.map(({ _id }) => _id);
        const orderedStatus = EdotcoStatusOrder.filter((x) => statusFilters.includes(x));
        const remainingStatusFilters = statusResponse.data.filter(({ _id }) => !EdotcoStatusOrder.includes(_id)).map(({ _id }) => _id);
        const formattedStatusFilters = [...orderedStatus, ...remainingStatusFilters].map((x) => ({
          filterName: x,
          isChecked: true,
          count: statusMap[x] || 0,
        }));
  
        setSiteStatusFilters((prev) => {
          const prevStatusMap = new Map(prev.map(({ filterName, isChecked }) => [filterName, isChecked]));
          return formattedStatusFilters.map((item) => ({
            ...item,
            isChecked: prevStatusMap.has(item.filterName) ? prevStatusMap.get(item.filterName) : true,
          }));
        });
      }
    } catch (err) {
      console.error("Error fetching site filters", err);
      toast.error(err.message, { theme: "colored" });
    }
  },[edotcoSubFilters?.dataType , edotcoSubFilters?.connectionType, selectedEdotcoSiteOperator?.value, selectedEdotcoSiteOperator?.operatorList, viewportSW, siteZoom, mapZoomLevel, edotcoSiteAreaToggle])

  const fetchActionFilters = useCallback(async () => {
    try {
      const actionFilters = {
        params: {
          groupBy: "siteRef",
          logicGate: selectedProposedOperator?.value && selectedProposedOperator?.operatorList?.length ? selectedProposedOperator.value : "",
          filters: `${edotcoSubFilters?.connectionType ? "connection_type:" + edotcoSubFilters?.connectionType : ""}${edotcoSubFilters?.dataType ? ",data_type:" + edotcoSubFilters?.dataType : ""}`,
          inFilters: selectedProposedOperator?.operatorList?.length ? "proposedTenants:" + selectedProposedOperator.operatorList.join("|") : "",
        },
      };
  
      const actionFilterParams = {
        adL: edotcoSiteAreaToggle && appliedFilters.level !== "geoHashLevel" ? appliedFilters.level : null,
        adLVal: edotcoSiteAreaToggle && appliedFilters.level !== "geoHashLevel" ? appliedFilters.levelVal : null,
        northEast: convertArrayToStringWithDelimeter(edotcoSiteAreaToggle && geohashNE.length ? geohashNE : viewportNE, "_"),
        southWest: convertArrayToStringWithDelimeter(edotcoSiteAreaToggle && geohashSW.length ? geohashSW : viewportSW, "_"),
        countryCode: appliedFilters.countryCode,
        year: appliedFilters.year,
        quarter: appliedFilters.quarter,
        column: "action",
        table: "edotco_site_statistics",
      };
  
      const actionResponse = await getFiltersWithLocation(actionFilterParams, actionFilters);
  
      if (actionResponse.success) {
        let isNoAction = false;
        const actionFilters = [];
        const actionMap = Object.fromEntries(actionResponse.data.map(({ _id, count }) => [_id, count]));
        actionResponse.data.forEach(({ _id }) => {
          if (_id !== "No Action") actionFilters.push(_id);
          else isNoAction = true;
        });
  
        const orderedActions = EdotcoActionOrder.filter((x) => actionFilters.includes(x));
        const remainingActionFilters = actionFilters.filter((x) => !EdotcoActionOrder.includes(x));
        const formattedActionFilters = [...orderedActions, ...remainingActionFilters].map((x) => ({
          filterName: x,
          isChecked: true,
          count: actionMap[x] || 0,
        }));
  
        if (isNoAction) formattedActionFilters.push({ filterName: "No Action", isChecked: true, count: actionMap["No Action"] || 0 });
  
        setSiteActionFilters((prev) => {
          const prevStatusMap = new Map(prev.map(({ filterName, isChecked }) => [filterName, isChecked]));
          return formattedActionFilters.map((item) => ({
            ...item,
            isChecked: prevStatusMap.has(item.filterName) ? prevStatusMap.get(item.filterName) : true,
          }));
        });
      }
    } catch (err) {
      console.error("Error fetching site filters", err);
      toast.error(err.message, { theme: "colored" });
    }
  },[edotcoSubFilters?.connectionType, edotcoSubFilters?.dataType, selectedProposedOperator?.value, selectedProposedOperator?.operatorList, viewportSW, siteZoom, mapZoomLevel, edotcoSiteAreaToggle])
  
  // useEffect for fetching both status and action filters
  useEffect(() => {
    if (isECoSitesChecked && viewportSW.length) {
      if (!edotcoSiteAreaToggle || !appliedFilters.level) {
        if (mapZoomLevel >= clusterDefaultZoomLvl || mapZoomLevel >= siteZoom) {
          fetchStatusFilters();
          fetchActionFilters();
        }
      } else {
        fetchStatusFilters();
        fetchActionFilters();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewportSW, edotcoSiteAreaToggle, isECoSitesChecked, siteZoom, appliedFilters, mapZoomLevel, fetchStatusFilters, fetchActionFilters]);
  
  useEffect(() => {
    if (
      isECoSitesChecked
    ) {
      // Handling filters for connection type and data type with permissions
      const fetchFilters = async () => {
        try {
            const promises = [];

            if (ecoCTPerm?.is_enable) {
                promises.push(
                    getFilters({
                        countryCode: appliedFilters.countryCode,
                        year: appliedFilters.year,
                        quarter: appliedFilters.quarter,
                        column: "connection_type",
                        table: "edotco_site_statistics",
                    })
                );
            } else {
                promises.push(null);
            }
    
            if (ecoDTPerm?.is_enable) {
                promises.push(
                    getFilters({
                        countryCode: appliedFilters.countryCode,
                        year: appliedFilters.year,
                        quarter: appliedFilters.quarter,
                        column: "data_type",
                        table: "edotco_site_statistics",
                    })
                );
            } else {
                promises.push(null);
            }
    
            const [connectionTypesResponse, dataTypesResponse] = await Promise.all(
                promises.map(p => p ?? Promise.resolve(null))
            );
    
            const connectionTypes = connectionTypesResponse?.data?.map((x) => ({
                label: x._id,
                value: x._id,
            })) || [];
            const sortedConnectionTypes = sortByReference(connectionTypes, DATA_ORDERS.CT, "label");
    
            const dataTypes = dataTypesResponse?.data?.map((x) => ({
                label: x._id,
                value: x._id,
            })) || [];
    
            setConnectionTypes(sortedConnectionTypes);
            setEdotcoDataTypes(dataTypes);
            setEdotcoSubFilters((prev) => ({
              ...prev,
              connectionType: sortedConnectionTypes[0]?.value,
              dataType: dataTypes[0]?.value,
            }));
        } catch (error) {
            console.error("Error fetching filters:", error);
        }
    };
  
      fetchFilters();
    }
  }, [appliedFilters.countryCode, appliedFilters.quarter, appliedFilters.year, ecoCTPerm?.is_enable, ecoDTPerm?.is_enable, isECoSitesChecked, setEdotcoSubFilters]);

  useEffect(() => {
    loadSiteRefDataToDropDown();
  }, [edotcoSiteAreaToggle, appliedFilters.level, appliedFilters.levelVal]);

  useEffect(() => {
    if(isStatusFilterSet && siteStatusFilters.length > 0 && siteActionFilters.length > 0) {
      setEdotcoSubFilters((prev) => ({...prev, status: siteStatusFilters, action: siteActionFilters }))
      setIsStatusFilterSet(false);
    }
  }, [siteStatusFilters, siteActionFilters]);

  useEffect(() => {
    setSiteStatusFilters([]);
    setSiteActionFilters([]);
  }, [appliedFilters.country, appliedFilters.year, appliedFilters.quarter]);

  // reset siterefs drawn on the map if eyeIcon or toggle off
  useEffect(() => {
    if (!eyeIcons.sites || !isECoSitesChecked) {
      setSelectedSiteRef([]);
      setIsStatusFilterSet(true);
    }
  }, [eyeIcons.sites, isECoSitesChecked]);

  useEffect(() => {
    const map = mapRef?.current;
    let listener;
    if (map) {
      listener = map.addListener('idle', () => {
        const bounds = mapRef.current.getBounds();
        setViewportNE([bounds.getNorthEast().lng(), bounds.getNorthEast().lat()]);
        setviewportSW([bounds.getSouthWest().lng(), bounds.getSouthWest().lat()]);
      });
    }

    return () => {
      if (map && listener) window.google.maps.event.clearListeners(map, 'idle', listener);
    };
  }, []);

  useEffect(() => {
    const init = async () => {
      if (isSitesChecked) {
        const mnoOperatorsET = operatorsPermittedECSiteET.filter(operator => operator.type === "MNO" && operator.is_others === false && operator.operator !== "Others");
        const mnoOperatorsETOthers = operatorsPermittedECSiteET.filter(operator => operator.type === "MNO" && operator.is_others === true);
        const nonMnoOperatorsETPermited = operatorsPermittedECSiteET.filter(operator => operator.type === "Non-MNO" && operator.is_others === false && operator.operator !== "Others");
        const nonMnoOperatorsETOthers = operatorsPermittedECSiteET.filter(operator => operator.type === "Non-MNO" && operator.is_others === true);
        setMnoOperatorsETPermited(mnoOperatorsET)
        setMnoOperatorsETOthers(mnoOperatorsETOthers)
        setNonMnoOperatorsETPermited(nonMnoOperatorsETPermited)
        setnonMnoOperatorsETOthers(nonMnoOperatorsETOthers)

        const mnoOperatorsProposed = operatorsPermittedECSitePT.filter(operator => operator.type === "MNO" && operator.is_others === false && operator.operator !== "Others");
        const mnoOperatorsProposedOthers = operatorsPermittedECSitePT.filter(operator => operator.type === "MNO" && operator.is_others === true);
        const nonMnoOperatorsProposed = operatorsPermittedECSitePT.filter(operator => operator.type === "Non-MNO" && operator.is_others === false);
        const nonMnoOperatorsProposedOthers = operatorsPermittedECSitePT.filter(operator => operator.type === "Non-MNO" && operator.is_others === true && operator.operator !== "Others");
        setMnoOperatorsProposedPermited(mnoOperatorsProposed)
        setMnoOperatorsProposedOthers(mnoOperatorsProposedOthers)
        setNonMnoOperatorsProposedPermited(nonMnoOperatorsProposed)
        setNonMnoOperatorsProposedOthers(nonMnoOperatorsProposedOthers)
      };
    }

    init();
  }, [isSitesChecked, operatorsPermittedECSiteET, operatorsPermittedECSitePT]);

  const checkAnonmyzedValues = async (opsArray, countryCode) => {
    const anonmizedOpsList = await getAnonymizedOperatorsByCountry(countryCode);
    const anonymizedArray = opsArray.filter(level => level.is_permitted === false && level.is_others === false && level.operator !== 'Others');
    const anonymizedOps = anonymizedArray?.map(op => {
      const anonymizedEntry = anonmizedOpsList.find(anon => anon.operator === op.operator);
      if (anonymizedEntry) {
        return {
          ...op,
          operator: anonymizedEntry.operator,
          name: anonymizedEntry.anonymizedName,
          isAnonymized: true,
        };
      }
      return {
        ...op,
        isAnonymized: false,
      };
    });
    const nonAnonymizedOps = opsArray.filter(op => 
      !anonymizedOps.some(anonOp => anonOp.operator === op.operator)
    );

    const processedNonAnonymizedOps = nonAnonymizedOps.map((op) => ({
      ...op,
      isAnonymized: false,
    }));
    return [...processedNonAnonymizedOps, ...anonymizedOps];
  };
  
  const onChangeGeoAreaFilter = () => {
    setEdotcoSiteAreaToggle(!edotcoSiteAreaToggle)
  }

  const onChangeEdotcoSiteOperator = useCallback((val) => {
    setSelectedEdotcoSiteOperator(val);
  }, []);

  const onChangeStatusFilter = ({ filterName }) => {
    let updatedStatusFilters = siteStatusFilters.map((item) => {
      if (filterName === item.filterName) {
        return { ...item, isChecked: !item.isChecked };
      }
      return item;
    });
    setSiteStatusFilters([...updatedStatusFilters]);
    setEdotcoSubFilters((prev)=>({...prev, status: updatedStatusFilters}))
  };

  const onChangeActionFilter = ({ filterName }) => {
    let updatedActionFilters = siteActionFilters.map((item) => {
      if (filterName === item.filterName) {
        return { ...item, isChecked: !item.isChecked };
      }
      return item;
    });
    setSiteActionFilters([...updatedActionFilters]);
    setEdotcoSubFilters((prev)=>({...prev, action: updatedActionFilters}))
  };

  const onChangeEdotcoProposedSiteOperator = useCallback((val) => {
    setSelectedProposedOperator(val);
  }, []);

  const getCheckedFilters = (filters) => {
    return filters
      .filter(item => item.isChecked)
      .map(item => item.filterName);
  }

  const getSitesCounts = useCallback(async () => {
    if (typeof cancelToken.current != typeof undefined) {
      cancelToken.current.cancel("Operation canceled due to new request.");
    }
    //Save the cancel token for the current request
    cancelToken.current = axios.CancelToken.source();
    clearTimeout(TOForSiteCount.current);

    TOForSiteCount.current = setTimeout(async () => {
      try {
        const checkedStatus = getCheckedFilters(siteStatusFilters);
        const checkedActions = getCheckedFilters(siteActionFilters);
        const { data } = await fetchEdotcoSiteCounts({
          countryCode: appliedFilters.countryCode,
          quarter: appliedFilters.quarter,
          year: appliedFilters.year,
          adL: edotcoSiteAreaToggle && appliedFilters.level !== 'geoHashLevel' ? appliedFilters.level : null,
          adLVal: edotcoSiteAreaToggle && appliedFilters.level !== 'geoHashLevel' ? appliedFilters.levelVal : null,
          northEast: convertArrayToStringWithDelimeter(edotcoSiteAreaToggle && geohashNE.length ? geohashNE : viewportNE, "_"),
          southWest: convertArrayToStringWithDelimeter(edotcoSiteAreaToggle && geohashSW.length ? geohashSW : viewportSW, "_"),
          status: convertArrayToStringWithDelimeter(checkedStatus, "_"),
          action: convertArrayToStringWithDelimeter(checkedActions, "_"),
          dataType: edotcoSubFilters?.dataType,
          connectionType: edotcoSubFilters?.connectionType,
        }, cancelToken.current);
        setSiteCounts(data);
      } catch (err) {
        if (err?.message === "Operation canceled due to new request.") return;
        console.log("Error while filtering site counts", err);
        toast.error(err.message, { theme: "colored" });
      }
    }, TOForSiteCount);
  },[siteStatusFilters.length,siteActionFilters.length, appliedFilters.countryCode, appliedFilters.quarter, appliedFilters.year, appliedFilters.level, appliedFilters.levelVal, viewportSW, edotcoSubFilters?.dataType, edotcoSubFilters?.connectionType, edotcoSiteAreaToggle])

    // get counts for view-port
    useEffect(() => {
      if (!edotcoSiteAreaToggle || !appliedFilters.level) {
        if (
          isSitesChecked &&
          isECoSitesChecked &&
          (mapZoomLevel >= clusterDefaultZoomLvl || mapZoomLevel >= siteZoom) &&
          siteStatusFilters.length > 0 &&
          siteActionFilters.length > 0 &&
          viewportSW.length
        ) {
          getSitesCounts();
        } else setSiteCounts({ exisTnatMNO: [], proposedMNO: [], exisTnatNONMNO: [], proposedNONMNO: [] });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      appliedFilters,
      siteStatusFilters.length,
      siteActionFilters.length,
      viewportSW,
      edotcoSiteAreaToggle,
      edotcoSubFilters.dataType,
      edotcoSubFilters.connectionType,
      isECoSitesChecked,
      isSitesChecked,
      siteZoom,
      getSitesCounts,
    ]);
  
    // get counts for area
    useEffect(() => {
      if (edotcoSiteAreaToggle && appliedFilters.level) {
        if (
          isSitesChecked &&
          isECoSitesChecked &&
          siteStatusFilters.length > 0 &&
          siteActionFilters.length > 0
        ) {
          getSitesCounts();
        } else setSiteCounts({ exisTnatMNO: [], proposedMNO: [], exisTnatNONMNO: [], proposedNONMNO: [] });
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      siteStatusFilters,
      siteActionFilters,
      appliedFilters.level,
      appliedFilters.levelVal,
      edotcoSiteAreaToggle,
      edotcoSubFilters.dataType,
      edotcoSubFilters.connectionType,
      isECoSitesChecked,
      isSitesChecked
    ]);

  const handleSearchSiteRef = (val) => {
    setSelectedSiteRef([]);
    if (val !== null && siteRefsDetails.length !== 0) {
      const selectedSiteDetailsToMap = siteRefsDetails
        .find(item => item?.siteRef === val);
      setTimeout(() => {
        setSelectedSiteRef([{ ...selectedSiteDetailsToMap, selected: true }])
      }, 600);
      setSelectedSiteRefDropDown(val)
    } else {
      setSelectedSiteRefDropDown();
    }
  }

  const loadSiteRefDataToDropDown = async () => {
    if (appliedFilters.countryCode) {
      let queryParams = {}
      queryParams.countryCode = appliedFilters.countryCode
      queryParams.quarter = appliedFilters.quarter
      queryParams.year = appliedFilters.year
      queryParams.adL = edotcoSiteAreaToggle && appliedFilters.level !== 'geoHashLevel' ? appliedFilters.level : null
      queryParams.adLVal = edotcoSiteAreaToggle && appliedFilters.level !== 'geoHashLevel' ? appliedFilters.levelVal : null
      const response = await getSiteRefs(queryParams)
      if (response?.data?.length > 0) {
        let siteRefsArr = response?.data?.map((item) => item?.siteRef)
        setSiteRefs(siteRefsArr)
        setSiteRefsDetails(response?.data)
      } else {
        setSiteRefs([])
        setSiteRefsDetails([])
        setSelectedSiteRefDropDown()
        setSelectedSiteRef([])
      }
    } else {
      return
    }
  }

  const resetRefsTable = (tableCloseType) => {
    if (tableCloseType === 'close') {
      const newArr = selectedSiteRef.map(obj => {
        const { tempRemoved, ...rest } = obj;
        return rest;
      });
      setSelectedSiteRef(newArr);
    }
    setAdvanceSiteRefData([]); // clear table rows
    setMasterChecked(false); // reset master check
    setOpenAdvanceSiteRef(false); // close table
  }

  return (
    <>
      {edotcoSitePerm && isSitesChecked && (
        <Grid
          container
          item
          style={{
            justifyContent: "space-between",
            textAlign: "left",
            font: "normal normal normal 13px/18px Open Sans",
            letterSpacing: "0px",
            color: "black",
            opacity: "1",
            padding: "10px 10px 0px 10px"
          }}
        >
          <ToggleTitleWrapper main>e.co Sites</ToggleTitleWrapper>
          <ToggleSwitch
            checked={isECoSitesChecked}
            onChange={(e) => {
              loadSiteRefDataToDropDown();
              handleECoSitesToggle(e)
            }}
          />
          {isECoSitesChecked && <>
              {ecoGAPerm?.is_enable === true && (
                <SitesAreaFilter
                  siteAreaToggle={edotcoSiteAreaToggle}
                  appliedFilters={appliedFilters}
                  onChangeGeoAreaFilter={onChangeGeoAreaFilter}
                />
              )}

              {(edotcoConnectionTypes.length > 0 ||
                edotcoDataTypes.length > 0) && (
                <ToggleButtonContainer container item>
                  {ecoCTPerm?.is_enable && (
                    <ConnectionTypeGroup
                      data={edotcoConnectionTypes}
                      value={edotcoSubFilters?.connectionType}
                      handleChange={(val) =>
                        setEdotcoSubFilters((prev) => ({
                          ...prev,
                          connectionType: val,
                        }))
                      }
                    />
                  )}
                  {ecoDTPerm?.is_enable && (
                    <Grid style={{ paddingTop: "10px", width: "100%" }}>
                      <SegmentedButtonGroup
                        data={edotcoDataTypes}
                        value={edotcoSubFilters?.dataType}
                        handleChange={(val) =>
                          setEdotcoSubFilters((prev) => ({
                            ...prev,
                            dataType: val,
                          }))
                        }
                      />
                    </Grid>
                  )}
                </ToggleButtonContainer>
              )}

              {exitingTenantsPerm?.is_enable === true && (
                <TenantSitesDetailsTile
                  operatorList={selectedEdotcoSiteOperator.operatorList}
                  logic={selectedEdotcoSiteOperator.value}
                  onchangeOperator={onChangeEdotcoSiteOperator}
                  isProposedTenants={false}
                  mnoOperatorsPermited={mnoOperatorsETPermited}
                  mnoOperatorsOthers={mnoOperatorsETOthers}
                  nonMnoOperatorsPermited={nonMnoOperatorsETPermited}
                  nonMnoOperatorsOthers={nonMnoOperatorsETOthers}
                  siteCounts={(mapZoomLevel >= clusterDefaultZoomLvl || mapZoomLevel >= siteZoom) ? siteCounts.exisTnatMNO : []}
                  siteCountsNonMno={(mapZoomLevel >= clusterDefaultZoomLvl || mapZoomLevel >= siteZoom) ? siteCounts.exisTnatNONMNO : []}
                />
              )}
              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                item
                style={{
                  justifyContent: "space-between",
                  margin: "15px 5px 0px",
                  padding: "10px",
                  font: "normal normal 550 13px/18px Open Sans",
                  background: "#FFFFFF 0% 0% no-repeat padding-box",
                  border: "1px solid #007842",
                  borderRadius: "5px",
                  opacity: "1",
                }}
              >
                <h4 style={{ margin: "0px" }}>Status</h4>
                {siteStatusFilters.length > 0 &&
                  siteStatusFilters.map((item) => {
                    return (
                      <Grid
                        container
                        xs={12}
                        sm={12}
                        md={12}
                        item
                        style={{
                          justifyContent: "space-between",
                          marginTop: "5px",
                        }}
                      >
                        <ToggleTitleWrapper>
                          {item.filterName} (
                          {mapZoomLevel >= clusterDefaultZoomLvl ||
                          mapZoomLevel >= siteZoom
                            ? item.count
                            : 0}
                          )
                        </ToggleTitleWrapper>
                        <ToggleSwitch
                          checked={item.isChecked}
                          onChange={() => {
                            onChangeStatusFilter(item);
                          }}
                        />
                      </Grid>
                    );
                  })}
              </Grid>
              {proposedTenantsPerm?.is_enable === true && (
                <Grid
                  container
                  xs={12}
                  sm={12}
                  md={12}
                  item
                  style={{
                    justifyContent: "space-between",
                    margin: "15px 5px 0px",
                    padding: "10px",
                    font: "normal normal 550 13px/18px Open Sans",
                    background: "#FFFFFF 0% 0% no-repeat padding-box",
                    border: "1px solid #007842",
                    borderRadius: "5px",
                    opacity: "1",
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <h4 style={{ margin: "0px" }}>Proposed</h4>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <IconWrapper2
                        data-testid="proposed-visible-icon"
                        clicked={!isProposedTowersVisible}
                        onClick={() => {
                          if (
                            siteActionFilters.length > 0 &&
                            siteActionFilters
                              .filter((x) => x.filterName !== "No Action")
                              .some((x) => x.isChecked)
                          ) {
                        setIsProposedTowersVisible(!isProposedTowersVisible);
                            setProposedSiteVisible(!isProposedTowersVisible);
                          }
                        }}
                      >
                        {isProposedTowersVisible ? (
                          <VisibilityOutlinedIcon
                            style={{ color: "green", fontSize: 17 }}
                          />
                        ) : (
                          <VisibilityOffOutlinedIcon
                            style={{ color: "green", fontSize: 17 }}
                          />
                        )}
                      </IconWrapper2>
                    </div>
                  </Grid>
                  {siteActionFilters.length > 0 &&
                    siteActionFilters.map((item) => {
                      return (
                        <Grid
                          container
                          xs={12}
                          sm={12}
                          md={12}
                          item
                          style={{
                            justifyContent: "space-between",
                            ...(item.filterName === "No Action"
                              ? { marginTop: "5px" }
                              : { margin: "5px 0px 0px 8px" }),
                          }}
                        >
                          <ToggleTitleWrapper>
                          {item.filterName} (
                            {mapZoomLevel >= clusterDefaultZoomLvl ||
                            mapZoomLevel >= siteZoom
                              ? item.count
                              : 0}
                            )
                          </ToggleTitleWrapper>
                          <ToggleSwitch
                            checked={item.isChecked}
                            onChange={() => {
                              onChangeActionFilter(item);
                            }}
                          />
                        </Grid>
                      );
                    })}
                  <TenantSitesDetailsTile
                    operatorList={selectedProposedOperator.operatorList}
                    logic={selectedProposedOperator.value}
                    onchangeOperator={onChangeEdotcoProposedSiteOperator}
                    mnoOperatorsPermited={mnoOperatorsProposedPermited}
                    mnoOperatorsOthers={mnoOperatorsProposedOthers}
                    nonMnoOperatorsPermited={nonMnoOperatorsProposedPermited}
                    nonMnoOperatorsOthers={nonMnoOperatorsProposedOthers}
                    isProposedTenants={true}
                    siteCounts={(mapZoomLevel >= clusterDefaultZoomLvl || mapZoomLevel >= siteZoom) ? siteCounts.proposedMNO : []}
                    siteCountsNonMno={(mapZoomLevel >= clusterDefaultZoomLvl || mapZoomLevel >= siteZoom) ? siteCounts.proposedNONMNO : []}
                  />
                </Grid>
              )}
          </>}

          {isECoSitesChecked && (
            <Grid
              container
              xs={12}
              sm={12}
              md={12}
              item
              style={{
                justifyContent: "space-between",
                margin: "15px 5px 0px",
                padding: "10px",
                font: "normal normal 550 13px/18px Open Sans",
                background: "#FFFFFF 0% 0% no-repeat padding-box",
                border: "1px solid #007842",
                borderRadius: "5px",
                opacity: "1",
              }}
            >
              Site Ref
              <Grid
                container
                xs={12}
                sm={12}
                md={12}
                item
                style={{
                  justifyContent: "space-between",
                  marginTop: "5px",
                }}
              >
                <Row>
                  <InfiniteDropdown
                    defaultVal={"Select siteRef"}
                    options={siteRefs}
                    control={selectedSiteRef.length === 0 ||
                      selectedSiteRef.length > 1 ||
                      (selectedSiteRef.length && selectedSiteRef[0]?.siteRef !== selectedSiteRefDropDown)
                      ? ''
                      : selectedSiteRefDropDown}
                    setControl={handleSearchSiteRef}
                    appliedFilters={appliedFilters}
                    siteRefs={siteRefs}
                    setSiteRefs={setSiteRefs}
                    siteRefsDetails={siteRefsDetails}
                    setSiteRefsDetails={setSiteRefsDetails}
                  />
                  <ToolWrapper
                    onClick={() => {
                      setOpenAdvanceSiteRef(true)
                    }}
                    isSelected={''}
                    id="site-adv-icon"
                    backgroundColor={
                      selectedSiteRef.length !== 0
                        ? "#4DB84880"
                        : "#f0f0f0"
                    }
                  >
                    {selectedSiteRef.length !== 0
                      ?
                      <Tooltip title={`${selectedSiteRef.length} Site${selectedSiteRef.length === 1 ? '' : 's'} Selected`}>
                        <img src={'/assets/searchIcon.png'} width={"18px"} height={"18px"} />
                      </Tooltip> :
                      <img src={'/assets/searchIcon.png'} width={"18px"} height={"18px"} />
                    }
                  </ToolWrapper>
                </Row>
              </Grid>
            </Grid>
          )}

          {isECoSitesChecked && (<DialogWrapper
              cancelLabel="Cancel"
              title="Site Ref"
              actionLabel={"Confirm Selection"}
              open={openAdvanceSiteRef}
              version
              isSiteRefModal={true}
              setOpenModal={setOpenAdvanceSiteRef}
              disable={false}
              acceptButton={() => {
              const selectedSiteDetailsToMap = advanceSiteRefData.filter(x => x.selected);
              const currentRefs = selectedSiteRef.filter(x => !x.tempRemoved);
              currentRefs.forEach(x => {
                const isVisible = advanceSiteRefData.find(y => y.siteRef === x.siteRef);
                  if (!isVisible) selectedSiteDetailsToMap.push(x);
              })
                setSelectedSiteRef(selectedSiteDetailsToMap);
              resetRefsTable('accept');
              }}
            cancelAction={() => resetRefsTable('close')}
            onClose={() => resetRefsTable('close')}
            >
              <ScrollableTable
                dataRows={advanceSiteRefData}
                setDataRows={setAdvanceSiteRefData}
                setMasterChecked={setMasterChecked}
                masterChecked={masterChecked}
              />
          </DialogWrapper>)}
        </Grid>
      )}
    </>
  );
}

export default memo(EdotCoSitesCards);
